import { fetchMFAPreference, getCurrentUser } from 'aws-amplify/auth'

export const COGNITO_MESSAGE_ACTIONS = {
  RESEND: 'RESEND',
  SUPPRESS: 'SUPPRESS',
}

export const MFA_SETUP_PATH = '/auth/setup-MFA'

const ENROLLED_MFA_METHODS = ['TOTP', 'SMS']

// Microsoft SSO signs in through Cognito's custom auth flow; Microsoft enforces MFA for those sessions
const SSO_AUTH_FLOW_TYPE = 'CUSTOM_WITHOUT_SRP'

/**
 * Whether the signed-in user still has to enroll an authenticator before using the app:
 * their company requires MFA, they signed in with a password and Cognito has no MFA method for them.
 *
 * @param {object} userData - `userData` from `getUserById`
 * @returns {Promise<boolean>}
 */
export const isMfaSetupPending = async (userData) => {
  if (userData?.Customer?.MFA !== true) {
    return false
  }

  const { signInDetails } = await getCurrentUser()
  if (signInDetails?.authFlowType === SSO_AUTH_FLOW_TYPE) {
    return false
  }

  const { preferred } = await fetchMFAPreference()
  return !ENROLLED_MFA_METHODS.includes(preferred)
}
